module.exports = __webpack_public_path__ + "img/128.4.a2c6a86b.png";